<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('재료명')">
              <el-input v-model="searchForm.stuffNm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('StuffForStoreSearch')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('StuffForStoreAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('StuffForStoreUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('StuffForStoreDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >

      <template v-if="checkAuthActionAccess('StuffForStoreAdd') || checkAuthActionAccess('StuffForStoreUp')">
        <el-popover
          placement="right"
          :width="$device.mobile ? '95%' : 600"
          trigger="click"
          :style="{ marginLeft: $device.mobile ? `` : `10px` }">
          <div>
            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    '* 양식 파일 첫줄 해더 이름 기준으로 데이타 업로드 됩니다. 수정 하시면 업로드 안되거나 오류 발생 할 수 있습니다.'
                  )
                }}
              </div>
            </div>
            <el-button
              :size="size"
              @click="downExcel"
              icon="el-icon-download"
              :style="{ marginLeft: $device.mobile ? `` : `10px` }"
              >{{ $t('업로드 양식 다운로드') }}</el-button
            >

            <el-divider></el-divider>

            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    '* 재료 데이터 업로드를 추가적으로 할 경우, 추가할 재료만 양식에 적어 업로드하여야 데이터 중복 등록이 되지 않습니다.'
                  )
                }}
              </div>
            </div>

            <el-upload
              :show-file-list="false"
              :action="`${APP_API_URL}/stuff/store/up`"
              with-credentials
              accept="application/vnd.ms-excel"
              :headers="uploadHeaders"
              style="display: inline; margin-left: 10px"
              :on-success="upSuccess"
              :on-error="upError">
              <el-button :size="size" icon="el-icon-upload">{{ $t('재료 데이타 업로드') }}</el-button>
            </el-upload>
          </div>

          <el-button slot="reference" :size="size" icon="el-icon-upload">{{ $t('재료 업로드') }}</el-button>
        </el-popover>
      </template>
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        sortable
        label-class-name="data_cnt"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <el-table-column
        :label="$t('재료명')"
        prop="stuffNmLan"
        min-width="200"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('원산지')"
        prop="stuffNationNm"
        min-width="200"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column :label="$t('설명')" prop="stuffDesc" min-width="300" show-overflow-tooltip></el-table-column>
    </el-table>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :md="inputForm.stuffInfos.length > 0 ? 12 : 24">
            <el-tabs value="info">
              <el-tab-pane :label="$t('기본 정보')" name="info">
                <el-row :gutter="20">
                  <el-col :span="inputForm.stuffInfos.length > 0 ? 24 : 12">
                    <el-form-item :label="$t('재료명')" :error="formError.stuffNm" required>
                      <el-input v-model="inputForm.stuffNm" maxlength="50" clearable show-word-limit>
                        <el-button
                          v-if="lans.length > 1"
                          slot="append"
                          :size="size"
                          @click="
                            dictionaryTp = 'nm'
                            dictionaryDialogFormVisible = true
                          "
                          icon="el-icon-search"
                          >{{ $t('다국어 조회') }}</el-button
                        >
                      </el-input>

                      <!-- 사전 선택 -->
                      <DictionaryDialog
                        :visible="dictionaryDialogFormVisible"
                        @close="dictionaryDialogFormVisible = false"
                        @selectDictionary="selectDictionary" />
                    </el-form-item>

                    <el-form-item :label="$t('원산지')" :error="formError.stuffNation">
                      <el-input v-model="inputForm.stuffNation" maxlength="50" clearable show-word-limit>
                        <el-button
                          v-if="lans.length > 1"
                          slot="append"
                          :size="size"
                          @click="
                            dictionaryTp = 'nation'
                            dictionaryDialogFormVisible = true
                          "
                          icon="el-icon-search"
                          >{{ $t('다국어 조회') }}</el-button
                        >
                      </el-input>
                    </el-form-item>

                    <el-form-item :label="$t('사용 가능 여부')" required>
                      <combo
                        :data="mainVue.code.useYn"
                        :model="inputForm.useYn"
                        @change="inputForm.useYn = $event"></combo>
                    </el-form-item>

                    <el-form-item :label="$t('설명')" :error="formError.stuffDesc">
                      <el-input
                        v-model="inputForm.stuffDesc"
                        type="textarea"
                        maxlength="250"
                        show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col :md="12">
            <el-tabs v-model="activiTab" v-if="inputForm.stuffInfos.length > 0">
              <el-tab-pane
                v-for="(item, index) in inputForm.stuffInfos"
                :key="item.lanTp.id"
                :label="item.lanTp.nm"
                :name="item.lanTp.id">
                <el-form-item
                  :label="$t('재료명')"
                  :error="formError['stuffInfos[' + index + '].stuffInfoNm']"
                  required>
                  <el-input
                    v-model="inputForm.stuffInfos[index].stuffInfoNm"
                    maxlength="50"
                    clearable
                    show-word-limit></el-input>
                </el-form-item>

                <el-form-item :label="$t('원산지')" :error="formError['stuffInfos[' + index + '].stuffInfoNation']">
                  <el-input
                    v-model="inputForm.stuffInfos[index].stuffInfoNation"
                    maxlength="50"
                    clearable
                    show-word-limit></el-input>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DictionaryDialog from '@/components/dictionary/DictionaryDialog.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { downloadExcelFile } from '@/utils/downloadExcelFile'
import { mapGetters } from 'vuex'

export default {
  mixins: [mainVueMixin],

  components: {
    DictionaryDialog,
  },

  data: function () {
    const data = initData()
    data.url = '/stuff/store'
    data.storeLans = []
    data.activiTab = ''

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.lans = []
    data.popTableData = []

    data.dictionaryDialogFormVisible = false
    data.searchText = ''
    data.dictionaryTp = 'nm' // nation

    data.closeDialogVisible = false
    return data
  },
  computed: {
    // 직접 업로드(`el-upload`)가 싣는 CSRF 헤더 — 스토어가 지금 토큰에서 셈한다(서버가 받는 이름 한 곳)
    ...mapGetters({ uploadHeaders: 'auth/csrfHeaders' }),
  },
  created: function () {
    this.initStore()
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {
        // 벨리데이션 메세지가 값은 있는데 Vue에서 표시 안해주는 현상 처리 하기 위함
        setTimeout(
          function () {
            var tmp = this.inputForm.stuffNm
            this.inputForm.stuffNm = this.inputForm.stuffNm + ' '
            this.inputForm.stuffNm = tmp

            var i = 100
            for (let val in newVal) {
              if (val.indexOf('stuffInfos') > -1) {
                if ('' != newVal[val]) {
                  if (i > Number(val.replace(/[^0-9]*/g, ''))) {
                    i = parseInt(val.replace(/[^0-9]*/g, ''))
                  }
                }
              }
            }

            if (100 != i) {
              this.activiTab = this.inputForm.stuffInfos[i].lanTp.id
            }
          }.bind(this),
          500
        )
      },
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        stuffNm: '',
        useYn: 'Y',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        stuffCd: 0,
        stuffNm: '',
        stuffNation: '',
        stuffInfos: [],
        useYn: 'Y',
        stuffDesc: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        stuffNm: '',
        stuffNation: '',
        useYn: '',
        stuffDesc: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].stuffCd
      }
    },
    initStore: function () {
      this.mainVue.$axios.search(
        '/store/getStore',
        null,
        function (result) {
          this.storeLans = result.lans
          this.initStoreLans(result)
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정
    initStoreLans: function (store) {
      this.lans = []
      this.lans.push(store.defaultLan)

      for (var i = 0, len = store.lans.length; i < len; i++) {
        this.lans.push(store.lans[i])
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('재료 추가')

      this.formError = this.initFormError()

      if (this.storeLans.length > 0) {
        this.inputForm.stuffInfos = []

        for (var i = 0, len = this.storeLans.length; i < len; i++) {
          this.formError['stuffInfos[' + i + '].stuffInfoNm'] = ''
          this.formError['stuffInfos[' + i + '].stuffInfoNation'] = ''

          this.inputForm.stuffInfos.push({
            lanTp: this.storeLans[i],
            stuffInfoNm: '',
            stuffInfoNation: '',
          })

          if (i === 0) {
            this.activiTab = this.storeLans[i].id
          }
        }
      }

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.stuffCd,
        function (result) {
          result.statu = 'U'
          result.title = this.$t('재료 수정')

          try {
            this.formError = this.initFormError()

            this.inputForm = result

            // 수정 시 매장 다국어 삭제 시 카테고리도 다국어 지워줌
            var stuffInfosTmp = []

            if (this.inputForm.statu == 'U') {
              stuffInfosTmp = util.copyObj(this.inputForm.stuffInfos)
            }

            this.inputForm.stuffInfos = []

            for (var i = 0, len = this.storeLans.length; i < len; i++) {
              this.formError['stuffInfos[' + i + '].stuffInfoNm'] = ''
              this.formError['stuffInfos[' + i + '].stuffInfoNation'] = ''

              var stuffInfoNm = ''
              var stuffInfoNation = ''

              if (this.inputForm.statu == 'U') {
                for (var k = 0, klen = stuffInfosTmp.length; k < klen; k++) {
                  if (stuffInfosTmp[k].lanTp.id == this.storeLans[i].id) {
                    stuffInfoNm = stuffInfosTmp[k].stuffInfoNm
                    stuffInfoNation = stuffInfosTmp[k].stuffInfoNation
                  }
                }
              }

              this.inputForm.stuffInfos.push({
                lanTp: this.storeLans[i],
                stuffInfoNm: stuffInfoNm,
                stuffInfoNation: stuffInfoNation,
              })

              if (i === 0) {
                this.activiTab = this.storeLans[i].id
              }
            }
          } catch (e) {}

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('재료 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      for (var i = 0, len = this.inputForm.stuffInfos.length; i < len; i++) {
        this.formError['stuffInfos[' + i + '].stuffInfoNm'] = ''
        this.formError['stuffInfos[' + i + '].stuffInfoNation'] = ''
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.stuffCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    searchDictionary: function () {
      this.mainVue.$axios.search(
        '/dictionary/search',
        { nm: this.searchText, dictionaryTpVal: 'stuff' },
        function (result) {
          this.popTableData = []

          for (var i = 0, len = result.length; i < len; i++) {
            var tmp = result[i]

            tmp[result[i].lan.id] = result[i].nm

            for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
              tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
            }

            this.popTableData.push(tmp)
          }
        }.bind(this),
        true
      )
    },
    // 키워드 데이타 선택
    selectDictionary: function (row) {
      for (var i = 0, len = this.lans.length; i < len; i++) {
        // 기본 언어 새팅
        if (0 == i) {
          if ('nm' == this.dictionaryTp) {
            this.inputForm.stuffNm = row[this.lans[i].id]
          } else {
            this.inputForm.stuffNation = row[this.lans[i].id]
          }
        } else {
          // 타언어 순서대로 등록
          if ('nm' == this.dictionaryTp) {
            this.inputForm.stuffInfos[i - 1].stuffInfoNm = row[this.lans[i].id]
          } else {
            this.inputForm.stuffInfos[i - 1].stuffInfoNation = row[this.lans[i].id]
          }
        }
      }

      this.dictionaryDialogFormVisible = false
    },
    // 양식 다운로드
    downExcel: function () {
      const url = this.url + '/down'

      downloadExcelFile(url)
    },
    upSuccess: function () {
      this.mainVue.$message({ type: 'success', message: this.$t('업로드 되었습니다') })
      this.search()
    },
    upError: function () {
      this.mainVue.$message({ type: 'error', message: this.$t('업로드 실패 하였습니다') })
    },
  },
}
</script>
